import React from 'react';

import './ratings-chart.scss';

interface RatingsChartProps {
  className?: string;
  hideLegendNumbers?: boolean;
  hideValue?: boolean;
  value?: number;
  valueMarker?: React.ReactNode;
}

function RatingsChart(props: RatingsChartProps) {
  const {
    className = '',
    hideLegendNumbers = false,
    hideValue = false,
    value = 0,
    valueMarker
  } = props;
  const widthPercentage = Math.max(0, value) * 20;
  const formattedValue =
    typeof value?.toFixed === 'function' ? value.toFixed(1) : value;

  return (
    <div className={`ratings-chart ${className}`} styleName="container">
      <div
        className="ratings-chart__background-outline"
        styleName="background-outline"
      >
        <div className="ratings-chart__background" styleName="background">
          <div
            className="ratings-chart__fill"
            style={{ width: `${widthPercentage}%` }}
            styleName="fill"
          />
          <div styleName="marks">
            {[1, 2, 3, 4].map(number => (
              <span
                className="ratings-chart__mark"
                key={number}
                styleName="mark"
              />
            ))}
          </div>
        </div>
      </div>
      {!hideLegendNumbers && (
        <div className="ratings-chart__series" styleName="series">
          {[0, 1, 2, 3, 4, 5].map(number => (
            <span key={number} styleName="legend">
              {number}
            </span>
          ))}
        </div>
      )}

      {value !== 0 && (
        <div
          className="ratings-chart__value"
          style={{
            left: `${widthPercentage}%`
          }}
          styleName="value"
        >
          {!hideValue && formattedValue}
          {!valueMarker ? (
            <>
              <span className="ratings-chart__triangle" styleName="triangle" />
              <span
                className="ratings-chart__value-mark"
                styleName="value-mark"
              />
            </>
          ) : (
            valueMarker
          )}
        </div>
      )}
    </div>
  );
}

export default RatingsChart;
